import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import {
    atLeastOneDigitRegex,
    atLeastOneLowercaseRegex,
    atLeastOneSpecialCharacterRegex,
    atLeastOneUppercaseRegex,
    AutocompleteState
} from '../models/passwords';

@Component({
    selector: 'hq-password-field',
    templateUrl: './password-field.component.html',
    styleUrls: ['./password-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordFieldComponent implements OnInit, OnChanges, OnDestroy {
    @Input() placeholder = 'Password';
    @Input() formName = 'password';
    @Input() isValidationDisabled: boolean;
    @Input() shouldDisplayRequirements: boolean;
    @Input() submitted?: boolean;
    @Input() autocomplete: AutocompleteState = 'off';
    @Output() markAsInitialized = new EventEmitter<AbstractControl>();

    formControl: FormControl;
    passwordControlType = 'password';
    passwordIcon = 'visibility';

    private isPasswordVisible = false;
    private readonly unsubscribe = new Subject<void>();

    ngOnInit(): void {
        // The field is always required, but may not need full validation
        const validators = [Validators.required];

        if (!this.isValidationDisabled) {
            validators.push(
                Validators.minLength(12),
                Validators.pattern(atLeastOneDigitRegex),
                Validators.pattern(atLeastOneLowercaseRegex),
                Validators.pattern(atLeastOneSpecialCharacterRegex),
                Validators.pattern(atLeastOneUppercaseRegex)
            );
        }

        this.formControl = new FormControl('', validators);

        this.markAsInitialized.emit(this.formControl);
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.submitted && !changes.submitted.firstChange) {
            if (this.submitted) {
                this.formControl.markAsTouched();
            }
        }
    }

    onTogglePasswordField(): void {
        this.isPasswordVisible = !this.isPasswordVisible;

        if (this.isPasswordVisible) {
            this.passwordIcon = 'visibility_off';
            this.passwordControlType = 'text';
        }
        else {
            this.passwordIcon = 'visibility';
            this.passwordControlType = 'password';
        }
    }
}
